/* BP PDP JS — variant chips, qty, price sync, sticky bar, buy now. */
(function () {
  if (window.__bpPdpInit) return;
  window.__bpPdpInit = true;

  /* The shop's money_format stores the rupee sign as the HTML entity &#8377;, so
     Shopify.formatMoney hands back raw entity text. Everything here writes with
     textContent (never innerHTML), which would print "&#8377;150" literally — decode first. */
  function bpDecode(s) {
    if (!s || s.indexOf('&') === -1) return s;
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return bpDecode(Shopify.formatMoney(cents));
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  /* Globo Product Options: reserved slot in the variant area. Wherever Globo mounts
     on the page, its block is ADOPTED (moved) into the slot so options render inline
     with the variant selection. Skeleton shows until adoption (or 12s timeout). */
  function initGloboSlot(pdp) {
    var slot = pdp.querySelector('[data-bp-globo-slot]');
    if (!slot || slot.__bpInit) return;
    slot.__bpInit = true;
    /* :not([data-bp-globo-slot]) — our own slot classes contain "globo" */
    var SEL = '[class*="globo"]:not([data-bp-globo-slot]), [id*="globo"], [class*="gpo-"], [id*="gpo-"]';

    function outermost(el) {
      var top = el, p = top.parentElement;
      while (p && p !== document.body && p !== document.documentElement && p.matches && p.matches(SEL)) {
        top = p; p = top.parentElement;
      }
      return top;
    }

    function adopt() {
      var nodes = document.querySelectorAll(SEL);
      var tops = [];
      nodes.forEach(function (n) {
        if (slot.contains(n)) return;
        if (n.tagName === 'SCRIPT' || n.tagName === 'STYLE' || n.tagName === 'LINK') return;
        var t = outermost(n);
        if (t === slot || slot.contains(t) || t.contains(slot)) return;
        if (tops.indexOf(t) === -1) tops.push(t);
      });
      if (tops.length) {
        tops.forEach(function (t) { slot.appendChild(t); });
        slot.classList.remove('bp-globo-slot--waiting');
        slot.style.minHeight = '0';
      }
      return tops.length > 0;
    }

    var obs = new MutationObserver(function () { adopt(); });
    obs.observe(document.body, { childList: true, subtree: true });
    adopt();
    setTimeout(function () {
      slot.classList.remove('bp-globo-slot--waiting');
      if (!slot.childElementCount) slot.style.minHeight = '0'; /* Globo never came (non-Globo product) */
      obs.disconnect();
    }, 12000);
  }

  function init() {
    var pdp = document.querySelector('[data-bp-pdp]');
    if (!pdp) return;

    initGloboSlot(pdp);

    var form = pdp.querySelector('[data-bp-product-form], form[action*="/cart/add"]');
    if (!form) return;

    var variantsEl = pdp.querySelector('[data-bp-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form.querySelector('[data-bp-variant-id]');
    var qtyInput = form.querySelector('[data-bp-qty-input]');
    var qtyValue = form.querySelector('[data-bp-qty-value]');
    var addBtn = form.querySelector('[data-bp-pdp-add]');

    var selected = [];
    pdp.querySelectorAll('[data-bp-option]').forEach(function (opt, i) {
      var active = opt.querySelector('.bp-chip--active');
      selected[i] = active ? active.getAttribute('data-bp-option-value') : null;
    });

    function currentVariant() {
      if (!variants.length) return null;
      if (!selected.length) return variants[0];
      return variants.find(function (v) {
        return selected.every(function (val, i) { return !val || v.options[i] === val; });
      }) || null;
    }

    function qty() { return parseInt(qtyInput ? qtyInput.value : '1', 10) || 1; }

    /* Both buy buttons follow the variant — the sticky one used to be left saying
       "Add · ₹x" and still enabled while the card above it read Sold out. */
    var buyBtns = [addBtn, pdp.querySelector('[data-bp-sticky-add]')].filter(Boolean);

    /* Legacy fallback for the PDP layouts whose buttons have no label span. Only worth
       caching when the page was rendered in stock — if it loaded sold out, the markup we
       would be restoring IS "Sold out". */
    buyBtns.forEach(function (b) {
      if (!b.querySelector('[data-bp-add-label]') && !b.disabled) b.dataset.bpAddHtml = b.innerHTML;
    });

    /* The old version wrote addBtn.textContent = 'Sold out', which replaced the button's
       whole contents — including the [data-bp-total] span nested inside it. So picking a
       sold-out colour destroyed the price element, and there was no branch to put the label
       back either: once sold out, the button stayed sold out for the rest of the visit even
       after choosing a colour that was in stock.

       Nothing is rewritten now. The label and the price are separate spans; this flips the
       label's text and hides the price, so both survive every switch. */
    function setBuyState(available) {
      buyBtns.forEach(function (b) {
        b.disabled = !available;

        var label = b.querySelector('[data-bp-add-label]');
        var price = b.querySelector('[data-bp-add-price]');
        if (label) {
          label.textContent = available ? (b.getAttribute('data-bp-add-label-text') || 'Add to cart') : 'Sold out';
          if (price) price.hidden = !available;
          return;
        }

        if (b.dataset.bpSold === '1' && available) {
          b.dataset.bpSold = '0';
          if (b.dataset.bpAddHtml) b.innerHTML = b.dataset.bpAddHtml;
          else b.textContent = 'Add to cart';
        } else if (b.dataset.bpSold !== '1' && !available) {
          b.dataset.bpSold = '1';
          b.textContent = 'Sold out';
        }
      });
    }

    /* ---------- gallery follows the variant ----------

       Picking a colour changed the price and the buy button but left the photo alone, so a
       Maroon racket was being sold under a picture of the black one.

       Shopify hands us the mapping already: each variant in [data-bp-variants] carries a
       featured_image, and its id matches one of the slides the section stamped with
       data-image-id. No second source of truth to keep in step — if a merchant reassigns a
       variant's image in admin, both sides move together.

       Variants with no image of their own (featured_image null) leave the gallery where it
       is, which is right: switching Size should not throw away the colour you are looking at.

       Scrolling the track rather than reordering slides means the existing scroll listener
       repaints the dots and the arrows still walk the full gallery. */
    var track = pdp.querySelector('[data-bp-si-carousel]');
    var colourIndex = parseInt(pdp.getAttribute('data-bp-colour-index'), 10);

    /* Same normalisation the section applies to data-alt, so the two always compare like
       for like: lowercase, trimmed, internal whitespace collapsed. */
    function norm(s) { return (s || '').toString().trim().toLowerCase().replace(/\s+/g, ' '); }

    /* The colour the shopper has chosen, or '' when the product has no colour option. */
    function colourOf(v) {
      if (!v || !v.options || isNaN(colourIndex) || colourIndex < 0) return '';
      return norm(v.options[colourIndex]);
    }

    /* ---------- gallery shows one colour at a time ----------

       Images are assigned to a colour by their alt text in admin. That is the only mapping
       Shopify offers here: a variant holds exactly ONE image, so "the variant's images"
       cannot come from the variant itself — a gallery built that way would be one photo.

       FALLING BACK IS THE IMPORTANT PART. Roughly half the catalogue has no alt text at all
       (Z-power 800 RP, Nano Fusion, the Duplex combos), some carries SEO text rather than a
       colour ("badminton rackets" on Cross Court Pro), and some products tag most colours
       but not all (Z-Ziggler has no Red). When nothing matches, every image is shown — the
       behaviour those products have today. An empty carousel is never a possible outcome.

       Matching is exact, not fuzzy. "Blue" would otherwise sweep up "Blue White" AND
       "Blue Yellow" on Z Power 900 RP+ Lite, which lists all three as separate colours, and
       silently merging two colourways is worse than showing everything. */
    function applyVariantImages(v) {
      if (!track) return;
      var slides = track.querySelectorAll('[data-image-id]');
      var dots = pdp.querySelectorAll('[data-bp-si-dots] span');
      if (!slides.length) return;

      var want = colourOf(v);
      var hits = [];
      if (want) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-alt') === want) hits.push(i);
        }
      }
      var showAll = hits.length === 0;

      for (var j = 0; j < slides.length; j++) {
        var on = showAll || hits.indexOf(j) !== -1;
        slides[j].hidden = !on;
        if (dots[j]) dots[j].hidden = !on;
      }

      /* Arrows and dots only make sense with more than one image left. */
      var visible = showAll ? slides.length : hits.length;
      ['[data-bp-si-prev]', '[data-bp-si-next]', '[data-bp-si-dots]'].forEach(function (sel) {
        var el = pdp.querySelector(sel);
        if (el) el.hidden = visible < 2;
      });

      return showAll;
    }

    function showVariantImage(v, smooth) {
      if (!track) return;

      /* Filter first: when the colour has its own images the first of them is already the
         right photo, so there is nothing to scroll to. */
      var showingAll = applyVariantImages(v);

      if (!showingAll) {
        track.scrollLeft = 0;
        var firstDot = pdp.querySelector('[data-bp-si-dots] span:not([hidden])');
        pdp.querySelectorAll('[data-bp-si-dots] span').forEach(function (d) { d.classList.remove('bp-on'); });
        if (firstDot) firstDot.classList.add('bp-on');
        return;
      }

      /* Untagged product — keep the old behaviour and jump to the variant's own image. */
      if (!v || !v.featured_image || !v.featured_image.id) return;
      var slide = track.querySelector('[data-image-id="' + v.featured_image.id + '"]');
      if (!slide) return;
      var left = slide.offsetLeft - track.offsetLeft;
      if (Math.abs(track.scrollLeft - left) < 2) return;   /* already there */
      track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    }

    /* First call is the page-load sync (and any ?variant= deep link) — jumping there without
       an animation, since there is nothing to animate away from. */
    var syncedOnce = false;

    function sync() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;

      showVariantImage(v, syncedOnce);
      syncedOnce = true;

      /* availability first: it can restore the button's price span, which the writes
         below then need to find */
      setBuyState(v.available);

      var priceEls = pdp.querySelectorAll('[data-bp-price], [data-bp-sticky-price]');
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      var totalEls = pdp.querySelectorAll('[data-bp-total], [data-bp-sticky-total]');
      totalEls.forEach(function (el) { el.textContent = money(v.price * qty()); });
      var svar = pdp.querySelector('[data-bp-sticky-variant]');
      if (svar) svar.textContent = v.title;
    }

    /* option chips */
    pdp.querySelectorAll('[data-bp-option]').forEach(function (opt) {
      var index = parseInt(opt.getAttribute('data-option-index'), 10);
      var label = opt.querySelector('[data-bp-option-current]');
      opt.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-bp-option-value]');
        if (!chip) return;
        selected[index] = chip.getAttribute('data-bp-option-value');
        /* aria-pressed has to move with the class. It was only ever set server-side, so
           the swatch that happened to load selected kept aria-pressed="true" for the rest
           of the visit — and bp-theme.css styles .bp-chip[aria-pressed="true"] the same
           red as the active class, which is why a second swatch sat there permanently
           ringed. Wrong for screen readers too: two options both reading as pressed. */
        opt.querySelectorAll('.bp-chip').forEach(function (c) {
          c.classList.remove('bp-chip--active');
          if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('bp-chip--active');
        if (chip.hasAttribute('aria-pressed')) chip.setAttribute('aria-pressed', 'true');
        if (label) label.textContent = selected[index];
        sync();
      });
    });

    /* qty */
    var dec = form.querySelector('[data-bp-qty-dec]');
    var inc = form.querySelector('[data-bp-qty-inc]');
    function setQty(n) {
      n = Math.min(Math.max(n, 1), 9);
      if (qtyInput) qtyInput.value = n;
      if (qtyValue) qtyValue.textContent = n;
      sync();
    }
    if (dec) dec.addEventListener('click', function () { setQty(qty() - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(qty() + 1); });

    /* ajax add to cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty() })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          if (window.bpAddedFx) window.bpAddedFx.pop(addBtn);
          var toast = document.querySelector('[data-bp-toast]');
          if (toast) {
            toast.textContent = 'Added to cart ✓';
            toast.hidden = false;
            setTimeout(function () { toast.hidden = true; }, 2200);
          }
          document.dispatchEvent(new CustomEvent('bp:cart:added'));
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (addBtn) addBtn.disabled = false; });
    });

    /* sticky bar add mirrors the form */
    var stickyAdd = pdp.querySelector('[data-bp-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    /* buy now → cart permalink checkout */
    var buyNow = pdp.querySelector('[data-bp-buy-now]');
    if (buyNow) buyNow.addEventListener('click', function () {
      var v = currentVariant();
      if (v) window.location.href = '/cart/' + v.id + ':' + qty();
    });

    /* sticky bar visibility — show once the add-to-cart button is scrolled PAST
       (button above the viewport), not merely off-screen below the fold */
    var bar = pdp.querySelector('[data-bp-sticky-bar]');
    var stickyTarget = pdp.querySelector('[data-bp-pdp-add]') || pdp.querySelector('.bp-pdp__buy-card');
    if (bar && stickyTarget && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        bar.classList.toggle('bp-visible', past);
      }, { threshold: 0 }).observe(stickyTarget);
    } else if (bar) {
      bar.classList.add('bp-visible');
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
